/* tslint:disable */
/* eslint-disable */
/**
 * WICSSend
 * API reference documentation for WICSSend
 *
 * The version of the OpenAPI document: 0.1.0-RC
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingCarriers: async (year: string, month: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getAppReportingCarriers', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getAppReportingCarriers', 'month', month)
            const localVarPath = `/api/reporting/summary/carriers/{year}/{month}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingKpi: async (year: string, month: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getAppReportingKpi', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getAppReportingKpi', 'month', month)
            const localVarPath = `/api/reporting/kpi/{year}/{month}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingLabelexport: async (year: string, month: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getAppReportingLabelexport', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getAppReportingLabelexport', 'month', month)
            const localVarPath = `/api/reporting/summary/carriers/{year}/{month}/export`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppReportingCarriers(year: string, month: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppReportingCarriers(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getAppReportingCarriers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppReportingKpi(year: string, month: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppReportingKpi(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getAppReportingKpi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} year 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppReportingLabelexport(year: string, month: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppReportingLabelexport(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getAppReportingLabelexport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportingApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportingApiGetAppReportingCarriersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingCarriers(requestParameters: ReportingApiGetAppReportingCarriersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppReportingCarriers(requestParameters.year, requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportingApiGetAppReportingKpiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingKpi(requestParameters: ReportingApiGetAppReportingKpiRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppReportingKpi(requestParameters.year, requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportingApiGetAppReportingLabelexportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppReportingLabelexport(requestParameters: ReportingApiGetAppReportingLabelexportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppReportingLabelexport(requestParameters.year, requestParameters.month, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAppReportingCarriers operation in ReportingApi.
 * @export
 * @interface ReportingApiGetAppReportingCarriersRequest
 */
export interface ReportingApiGetAppReportingCarriersRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingCarriers
     */
    readonly year: string

    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingCarriers
     */
    readonly month: string
}

/**
 * Request parameters for getAppReportingKpi operation in ReportingApi.
 * @export
 * @interface ReportingApiGetAppReportingKpiRequest
 */
export interface ReportingApiGetAppReportingKpiRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingKpi
     */
    readonly year: string

    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingKpi
     */
    readonly month: string
}

/**
 * Request parameters for getAppReportingLabelexport operation in ReportingApi.
 * @export
 * @interface ReportingApiGetAppReportingLabelexportRequest
 */
export interface ReportingApiGetAppReportingLabelexportRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingLabelexport
     */
    readonly year: string

    /**
     * 
     * @type {string}
     * @memberof ReportingApiGetAppReportingLabelexport
     */
    readonly month: string
}

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
    /**
     * 
     * @param {ReportingApiGetAppReportingCarriersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getAppReportingCarriers(requestParameters: ReportingApiGetAppReportingCarriersRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getAppReportingCarriers(requestParameters.year, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportingApiGetAppReportingKpiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getAppReportingKpi(requestParameters: ReportingApiGetAppReportingKpiRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getAppReportingKpi(requestParameters.year, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportingApiGetAppReportingLabelexportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getAppReportingLabelexport(requestParameters: ReportingApiGetAppReportingLabelexportRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getAppReportingLabelexport(requestParameters.year, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }
}

